<template>
  <smart-select
    :value="value"
    :items="sourceItems"
    :item-text="sourceItemText"
    :item-value="sourceItemValue"
    :label="label"
    :loading="sourceLoading"
    :disabled="readonly"
    @input="$emit('input', $event)"
  />
</template>

<script>
import fieldSource from '../../mixins/fieldSource'

export default {
  name: 'SourceField',
  components: {
    SmartSelect: () => import('../../SmartSelect.vue'),
  },
  mixins: [fieldSource],
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
      required: true,
    },
    siblingValues: {
      type: Object,
      default: () => ({}),
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    sourceDependsValue() {
      if (this.hasSource) {
        this.loadSourceItems()
      }
    },
  },
  created() {
    if (this.hasSource) {
      this.loadSourceItems()
    }
  },
}
</script>
